<osp-panel class="contact-validation-panel">
  <ng-template ospTemplate="header">
    @if (themeService.theme$ | async | logoImage: null; as logo) {
      <img class="logo" [src]="logo" alt="{{ 'modules.contact.mail.validation.title' | translate }}" />
    }
  </ng-template>
  <h1>
    @if ($isValidation()) {
      {{ 'modules.contact.mail.validation.title' | translate }}
    } @else {
      {{ 'modules.contact.mail.revocation.title' | translate }}
    }
  </h1>
  <osp-content-loading-container [isLoading]="$isLoading()">
    <div class="content">
      <div class="contact-validation-panel">
        <div class="contact-result-wrapper">
          @if ($isSuccess()) {
            <div class="contact-success-panel">
              <div>
                <span class="contact-validation-result-message">
                  @if ($isValidation()) {
                    {{ 'modules.contact.mail.validation.success' | translate }}
                  } @else {
                    {{ 'modules.contact.mail.revocation.success' | translate }}
                  }
                </span>
              </div>
            </div>
          } @else {
            <div class="contact-failure-panel">
              <div>
                <span class="contact-validation-result-message">
                  @if ($isValidation()) {
                    {{ 'modules.contact.mail.validation.failed' | translate }}
                  } @else {
                    {{ 'modules.contact.mail.revocation.failed' | translate }}
                  }
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </osp-content-loading-container>
  <ng-template ospTemplate="footer">
    <osp-public-footer class="footer"></osp-public-footer>
  </ng-template>
</osp-panel>
